<template>
  <div class="flex flex-col gap-[16px]">
    <h1
      class="font-[Inter] text-[1.5rem] leading-[2.5rem] text-white font-black tracking-[-0.03em]"
    >
      Announcements
    </h1>
    <div
      v-for="(item, index) in announcements"
      :key="index"
      @click="navigate(item.path, item.linkType, item.dataEventTracking)"
    >
      <img
        class="w-full aspect-video rounded-[16px] object-cover"
        :src="item.imageSrc"
        alt="Announcement Image"
      />
    </div>
  </div>
</template>

<script>
import { trackContentClick } from '@/utils/analytics';

export default {
  props: {
    announcements: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    navigate(path, type, dataEventTracking) {
      trackContentClick({
        contentType: 'service_highlight_announcement',
        contentId: dataEventTracking,
        title: dataEventTracking,
        sourceSection: 'service-highlights-announcements',
        destination: path,
        isExternal: type === 'externalURL' || type === 'inAppBrowserURL',
        source: 'service-highlights-announcements',
      });
      this.$emit('navigate', { path, type, dataEventTracking });
    },
  },
};
</script>
